import type { FaireProductEntity } from "../../entity_types/product";

export const p_caehvvnybb: FaireProductEntity = {
  token: "p_caehvvnybb",
  type: "product",
  name: "Where's the Reindeer Poo?",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/03f9fd201349d77f5bc14041e075d241cb2ecacdf62df082e3ba7a3a2df67cf9.jpeg",
  galleryImageUrls: [],
  priceDollars: 8,
  description: "It's beginning to smell a lot like Christmas!\n\nRudy the Reindeer Poo and his festive friends are on an adventure to drop off all their Christmas deliveries. But ho, oh no! They keep getting lost... can you find them?\n\nThe perfect stocking-filler, this Christmas activity book comes from the bestselling creator of 'Where's the Poo?'",
  tags: [],
  msrpDollars: 15.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:52.263Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
